<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-camp-enrollment-session-search-criteria
                [searchForm]="searchForm"
            ></app-camp-enrollment-session-search-criteria>
        </div>

        <div class="col">
            <div
                class="row no-gutters top-panel height-80 line-height-40 padding-20"
            >
                @if (camp) {
                    <div class="col-md-auto">
                        <app-camp-icon
                            [iconName]="camp.categoryIcon"
                        ></app-camp-icon>
                    </div>
                }

                @if (camp) {
                    <div class="col line-height-20">
                        <div class="bolded">
                            {{ camp.name }} ({{ camp.categoryName }})
                        </div>
                        <div>
                            {{ camp.startDate | bcDate }} -
                            {{ camp.endDate | bcDate }}
                        </div>
                    </div>
                }

                <div class="col">
                    <div class="right">
                        <input
                            class="form-control"
                            [(ngModel)]="searchText"
                            placeholder="search"
                        />
                    </div>
                </div>
            </div>

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div class="list-group list-group-flush">
                    @for (
                        session of sessions | filter: searchText : searchFields;
                        track session
                    ) {
                        <div
                            class="list-group-item flex-column align-items-start clickable"
                        >
                            <app-session-enrollment-item
                                [session]="session"
                            ></app-session-enrollment-item>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
